import Form from "./Form.vue";
import Text from "./inputs/Text.vue";
import InputNumber from "./inputs/Number.vue";
import Select from "./inputs/Select.vue";

export default {
  install(App) {
    App.component("v-form", Form);

    App.component("v-input", Text);
    App.component("v-input-number", InputNumber);
    App.component("v-input-select", Select);
  }
};
